import React, {useEffect, useRef, useState} from 'react';
import {ReactComponent as ButtonSVG1} from '../images/color-button-1.svg';

import Button1Img from '../images/color-button-1.png';
import Button2Img from '../images/color-button-2.png';
import Button3Img from '../images/color-button-3.png';
import Button4Img from '../images/color-button-4.png';
import Button5Img from '../images/color-button-5.png';
import Button6Img from '../images/color-button-6.png';
import Button7Img from '../images/color-button-7.png';
import Button8Img from '../images/color-button-8.png';
import Button9Img from '../images/color-button-9.png';
import Button10Img from '../images/color-button-10.png';
import Button11Img from '../images/color-button-11.png';
import Button12Img from '../images/color-button-12.png';

import Button1HoverImg from '../images/color-button-1--hover.png';
import Button2HoverImg from '../images/color-button-2--hover.png';
import Button3HoverImg from '../images/color-button-3--hover.png';
import Button4HoverImg from '../images/color-button-4--hover.png';
import Button5HoverImg from '../images/color-button-5--hover.png';
import Button6HoverImg from '../images/color-button-6--hover.png';
import Button7HoverImg from '../images/color-button-7--hover.png';
import Button8HoverImg from '../images/color-button-8--hover.png';
import Button9HoverImg from '../images/color-button-9--hover.png';
import Button10HoverImg from '../images/color-button-10--hover.png';
import Button11HoverImg from '../images/color-button-11--hover.png';
import Button12HoverImg from '../images/color-button-12--hover.png';

const Buttons = [
    Button1Img,
    Button2Img,
    Button3Img,
    Button4Img,
    Button5Img,
    Button6Img,
    Button7Img,
    Button8Img,
    Button9Img,
    Button10Img,
    Button11Img,
    Button12Img
];

const HoverButtons = [
    Button1HoverImg,
    Button2HoverImg,
    Button3HoverImg,
    Button4HoverImg,
    Button5HoverImg,
    Button6HoverImg,
    Button7HoverImg,
    Button8HoverImg,
    Button9HoverImg,
    Button10HoverImg,
    Button11HoverImg,
    Button12HoverImg
];

type ColorButtonProps = {
    color: number,
    onColorChange: (value: number, index: number) => void,
    index: number,
    selected: boolean
};

export const ColorButton = (props: ColorButtonProps) => {

    const ref = useRef<SVGSVGElement>(null);

    const [colorStr] = useState(() => {
        return `#${('000000' + props.color.toString(16)).substr(-6)}`;
    });

    useEffect(() => {
        const path: any = ref.current?.querySelector('path.fill-obj');
        // const path = ref.current?.querySelector('path');
        if (path) path.style.fill = colorStr;
        if (path && colorStr === '#ffffff') path.style.stroke = '#c6c6c6';
    });

    const onClick = () => {
        props.onColorChange(props.color, props.index);
    };

    const buttonImg = Buttons[props.index];
    const hoverButtonImg = HoverButtons[props.index];

    return (
        <div className={"drawing-page__color-button" + (props.selected ? ' selected' : '')} onClick={onClick}>
            <img
                src={props.selected?hoverButtonImg:buttonImg}
                onMouseOver={e => e.currentTarget.src = hoverButtonImg}
                onMouseOut={e => e.currentTarget.src = props.selected?hoverButtonImg:buttonImg}
            />
        </div>
    );
};